var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/public-layout/components/header.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { logIn, verifyCredentials } from 'soapbox/actions/auth';
import { fetchInstance } from 'soapbox/actions/instance';
import { openModal } from 'soapbox/actions/modals';
import SiteLogo from 'soapbox/components/site-logo';
import { Button, Form, HStack, IconButton, Input, Tooltip } from 'soapbox/components/ui';
import { useAppSelector, useFeatures, useSoapboxConfig, useOwnAccount } from 'soapbox/hooks';
import Sonar from './sonar';
const messages = defineMessages({
  home: {
    "id": "header.home.label",
    "defaultMessage": "Home"
  },
  login: {
    "id": "header.login.label",
    "defaultMessage": "Log in"
  },
  register: {
    "id": "header.register.label",
    "defaultMessage": "Register"
  },
  username: {
    "id": "header.login.username.placeholder",
    "defaultMessage": "Email or username"
  },
  password: {
    "id": "header.login.password.label",
    "defaultMessage": "Password"
  },
  forgotPassword: {
    "id": "header.login.forgot_password",
    "defaultMessage": "Forgot password?"
  }
});

const Header = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const account = useOwnAccount();
  const soapboxConfig = useSoapboxConfig();
  const pepeEnabled = soapboxConfig.getIn(['extensions', 'pepe', 'enabled']) === true;
  const {
    links
  } = soapboxConfig;
  const features = useFeatures();
  const instance = useAppSelector(state => state.instance);
  const isOpen = features.accountCreation && instance.registrations;
  const pepeOpen = useAppSelector(state => state.verification.instance.get('registrations') === true);
  const [isLoading, setLoading] = React.useState(false);
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [shouldRedirect, setShouldRedirect] = React.useState(false);
  const [mfaToken, setMfaToken] = React.useState(false);

  const open = () => dispatch(openModal('LANDING_PAGE'));

  const handleSubmit = event => {
    event.preventDefault();
    setLoading(true);
    dispatch(logIn(username, password)).then(_ref => {
      let {
        access_token
      } = _ref;
      return dispatch(verifyCredentials(access_token)) // Refetch the instance for authenticated fetch
      .then(() => dispatch(fetchInstance())).then(() => setShouldRedirect(true));
    }).catch(error => {
      var _error$response;

      setLoading(false);
      const data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;

      if ((data === null || data === void 0 ? void 0 : data.error) === 'mfa_required') {
        setMfaToken(data.mfa_token);
      }
    });
  };

  if (account && shouldRedirect) return /*#__PURE__*/React.createElement(Redirect, {
    to: "/",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 41
    }
  });
  if (mfaToken) return /*#__PURE__*/React.createElement(Redirect, {
    to: "/login?token=".concat(encodeURIComponent(mfaToken)),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 24
    }
  });
  return /*#__PURE__*/React.createElement("header", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("nav", {
    className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
    "aria-label": "Header",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full py-6 flex items-center justify-between border-b border-indigo-500 lg:border-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sm:justify-center relative w-36",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block absolute z-0 -top-24 -left-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Sonar, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(IconButton, {
    title: "Open Menu",
    src: require('@tabler/icons/menu-2.svg'),
    onClick: open,
    className: "md:hidden mr-4 bg-transparent text-gray-700 dark:text-gray-600 hover:text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: "z-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    alt: "Logo",
    className: "h-6 w-auto cursor-pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 15
    }
  }, intl.formatMessage(messages.home)))), /*#__PURE__*/React.createElement("div", {
    className: "ml-10 flex space-x-6 items-center relative z-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 6,
    alignItems: "center",
    className: "hidden md:flex md:mr-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 15
    }
  }, links.get('help') && /*#__PURE__*/React.createElement("a", {
    href: links.get('help'),
    target: "_blank",
    className: "text-sm font-medium text-gray-700 dark:text-gray-600 hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 19
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "landing_page_modal.helpCenter",
    defaultMessage: "Help Center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 106,
      columnNumber: 21
    }
  }))), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    className: "xl:hidden shrink-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Button, {
    to: "/login",
    theme: "tertiary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 17
    }
  }, intl.formatMessage(messages.login)), (isOpen || pepeEnabled && pepeOpen) && /*#__PURE__*/React.createElement(Button, {
    to: "/signup",
    theme: "primary",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 19
    }
  }, intl.formatMessage(messages.register)))), /*#__PURE__*/React.createElement(Form, {
    className: "hidden xl:flex space-x-2 items-center",
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Input, {
    required: true,
    value: username,
    onChange: event => setUsername(event.target.value.trim()),
    type: "text",
    placeholder: intl.formatMessage(messages.username),
    className: "max-w-[200px]",
    autoCorrect: "off",
    autoCapitalize: "off",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Input, {
    required: true,
    value: password,
    onChange: event => setPassword(event.target.value),
    type: "password",
    placeholder: intl.formatMessage(messages.password),
    className: "max-w-[200px]",
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/reset-password",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    text: intl.formatMessage(messages.forgotPassword),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    src: require('@tabler/icons/help.svg'),
    className: "bg-transparent text-gray-700 dark:text-gray-600 hover:text-gray-800 dark:hover:text-gray-500 cursor-pointer",
    iconClassName: "w-5 h-5",
    transparent: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 19
    }
  }))), /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 15
    }
  }, intl.formatMessage(messages.login)))))));
};

export default Header;